import BlogContent from "../../components/BlogContent";

export default function Blog() {
  return (
    <div>
        <BlogContent/>
    </div>
  );
}
